import React, { useState, useEffect } from "react";
import { getPopular } from "src/api/MessageApi";

import SearchBox from "src/components/ui/SearchBox";
import SearchButton from "src/components/button/SearchButton";
import { searchStock } from "src/api/MainApi";

const SearchContainer: React.FC = () => {
    const [searchResults, setSearchResults] = useState([]);
    const [hasSearched, setHasSearched] = useState(false);
    const [popStocks, setPopStocks] = useState([])
    useEffect(() => {
        const fetchData = async () => {
            try {
            const popRes = await getPopular(null);
            setPopStocks(popRes.data.list.map(({ isu_srt_cd, isu_kor_abbrv }) => ({
                isu_srt_cd,
                isu_kor_abbrv,
            })))
            } catch (error) {
            console.error("API 호출 실패:", error);
            }
        };
        fetchData();
      }, []);


    const handleSearch = async (query: string) => {
        try {
            let response;
            response = await searchStock(query);
            setSearchResults(response.data);
            setHasSearched(true);
        } catch (error) {
            console.error("검색 실패:", error);
        }
    };
    return (
        <div className="container mt-4" style={{ maxWidth: "582px" }}>
            <SearchBox onSearch={handleSearch} />
            <div className="mx-auto" style={{ maxWidth: "600px" }}>
                {!hasSearched ? (
                    <>
                        <h5 className="fw-bold mb-3">인기 종목</h5>
                        <div className="list-group">
                            <SearchButton results={popStocks} />
                        </div>
                    </>
                ) : (
                    <>
                        <h5 className="fw-bold mb-3">검색 결과</h5>
                        <div className="list-group">
                            {searchResults && searchResults.length > 0 ? (
                                <SearchButton results={searchResults} />
                            ) : (
                                <p className="text-muted">검색 결과가 없습니다.</p>
                            )}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default SearchContainer;
